import {
  ADD_ARCHIVES,
  ADD_NOTIFICATIONS,
  ADD_ROLES,
  ADD_USER,
  CLEAR_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  SET_ACTIVE,
  USER_LOGOUT
} from './action-types';

/**
 * Add notifcations action.
 * @param {*} payload
 * @return {*} the add user action.
 */
export function addNotifications(payload) {
  return {type: ADD_NOTIFICATIONS, payload};
}

/**
 * Remove notifcation action.
 * @param {*} payload
 * @return {*} the add user action.
 */
export function removeNotification(payload) {
  return {type: REMOVE_NOTIFICATION, payload};
}

/**
 * Clear notifcation action.
 * @param {*} payload
 * @return {*} the add user action.
 */
export function clearNotifications() {
  return {type: CLEAR_NOTIFICATIONS};
}

/**
 * Add user action.
 * @param {*} payload
 * @return {*} the add user action.
 */
export function addUser(payload) {
  return {type: ADD_USER, payload};
}

/**
 * Add roles action.
 * @param {*} payload
 * @return {*} the add user action.
 */
export function addRoles(payload) {
  return {type: ADD_ROLES, payload};
}

/**
 * Logout user and remove user object.
 * @return {*} the logout user action.
 */
export function logoutUser() {
  return {type: USER_LOGOUT};
}

/**
 * Logout user action.
 * @param {*} payload
 * @return {*} the logout user action.
 */
export function addArchives(payload) {
  return {type: ADD_ARCHIVES, payload};
}

/**
 * Logout user action.
 * @param {*} payload
 * @return {*} the logout user action.
 */
export function setActive(payload) {
  return {type: SET_ACTIVE, payload};
}
